import { useDownloadScreenshot } from '@va/dashboard/util-hooks';
import { useTranslate } from '@va/localization';
import { DownloadBtn, DownloadBtnTooltipContent } from '@va/ui/components/buttons';
import { RefObject } from 'react';

export type InstantDownloadNodeProps = {
  reportBlockRef: RefObject<HTMLDivElement | null>;
  fileName: string;
  /** Called inside the node, so it can read the RB contexts (filters, comparison) */
  useExportData: () => { downloadCSV: () => void; downloadXLSX: () => void };
};

const useInstantDownloadHandlers = ({ reportBlockRef, fileName, useExportData }: InstantDownloadNodeProps) => {
  const { downloadCSV, downloadXLSX } = useExportData();
  const { downloadPDFfunc, downloadPNGfunc } = useDownloadScreenshot(reportBlockRef, fileName);

  return { downloadCSV, downloadXLSX, downloadPDF: downloadPDFfunc, downloadPNG: downloadPNGfunc };
};

export const InstantDownloadHeaderNode = (props: InstantDownloadNodeProps) => {
  const translate = useTranslate();
  const handlers = useInstantDownloadHandlers(props);

  return <DownloadBtn {...handlers} title={translate('all.exportType.instant')} />;
};

export const InstantDownloadMenuComponent = (props: InstantDownloadNodeProps) => {
  const handlers = useInstantDownloadHandlers(props);

  return <DownloadBtnTooltipContent {...handlers} />;
};
